import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

const BASE_URL = process.env.REACT_APP_API;

export const EmployeeApi = createApi({
  reducerPath: 'EmployeeApi',
  tagTypes: ['Employees', 'CrewManagers', 'SrCrewManagers'],
  baseQuery: fetchBaseQuery({baseUrl: `${BASE_URL}/employees`}),
  endpoints: (builder) => ({
    getEmployees: builder.query({
      query: () => `/list`,
      onQueryStarted: () => {
        console.log('getEmployees query started');
      },
      providesTags: ['Employees'],
    }),
    getCrewManagers: builder.query({
      query: () => `/list/19`,
      onQueryStarted: () => {
        console.log('getCrewManagers query started');
      },
      providesTags: ['CrewManagers'],
    }),
    getSrCrewManagers: builder.query({
      query: () => `/list/20`,
      onQueryStarted: () => {
        console.log('getSrCrewManagers query started');
      },
      providesTags: ['SrCrewManagers'],
    }),
  }),
});

export const { useGetEmployeesQuery, useGetCrewManagersQuery, useGetSrCrewManagersQuery } = EmployeeApi;
